angular.module('tgaAdmin')
  .controller('ReportsController', [
    '$scope', '$state', '$timeout', 'domainService', 'reportService', 'gameService',
    '$filter', '$uibModal', 'localStorageService', 'constants', 'tzService', 'settingsService',
    function (
      $scope, $state, $timeout, domainService, reportService, gameService,
      $filter, $uibModal, localStorageService, constants, tzService, settingsService,
    ) {
      $scope.data = {
        alerts: [],
        filedate: moment().format('YYYY-MM-DD HH-mm-ss'),
        separator: ',',
        decimalSeparator: '.',
        gameTypes: gameService.getGameTypes(),
        userTypes: constants.userTypes(),
        selectedDates: {
          startDate: moment().subtract(29, 'days'),
          endDate: moment(),
        },
        datePickerOptions: settingsService.getDatePickerOptions({
          ranges: {
            'All Time': [moment('01 Jan 2017'), moment()],
          },
        }, {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day')
              || !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.actions.loadOrders();
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        }),
      };

      $scope.viewmodel = {
        range: 'Last 30 Days',
        oldRange: {
          startDate: moment().subtract(29, 'days').startOf('day'),
          endDate: moment().endOf('day'),
        },
        dateRange: {
          startDate: moment().subtract(29, 'days').startOf('day'),
          endDate: moment().endOf('day'),
        },
        orders: [],
        domains: [],
        users: [],
      };

      $scope.actions = {
        setupParams(tableState, endDate, startDate) {
          const params = tableState
            ? {
              paginate: true,
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
              start_date: startDate ? new Date(startDate) : null,
              end_date: endDate ? new Date(endDate) : null,
            }
            : {
              paginate: true,
              page: 1,
              start_date: startDate ? new Date(startDate) : null,
              end_date: endDate ? new Date(endDate) : null,
            };
          if (tableState?.search?.predicateObject) {
            Object.keys(tableState.search.predicateObject).forEach((key) => {
              params[key] = tableState.search.predicateObject[key];
            });
          }
          return params;
        },
        loadOrders(tableState) {
          $scope.loading = true;
          if (tableState) $scope.currTableState = tableState;
          const { endDate, startDate } = $scope.viewmodel.dateRange;
          const params = $scope.actions.setupParams(tableState, endDate, startDate);

          reportService.getOrdersReport(params).then((orders) => {
            $scope.viewmodel.orders = orders.items || orders;

            if (!tableState) {
              tableState = $scope.currTableState;
              tableState.pagination.start = 0;
              tableState.pagination.start2 = 0;
            }

            tableState.pagination.numberOfPages = Math.ceil(orders.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = orders.total;
            $scope.loading = false;
          });

          if (!$scope.viewmodel.ordersTotal) {
            $scope.viewmodel.ordersTotal = $scope.actions.exportOrderReport($scope.currTableState);
          }
        },
        exportCSV() {
          return $scope.actions.exportOrderReport($scope.currTableState);
        },
        exportOrderReport(tableState) {
          const reportData = [];
          reportData.push([
            'Order Date',
            'Order ID',
            'User ID',
            'Name',
            'Email Address',
            'Phone Number',
            'Company',
            'Domain',
            'Affiliate',
            'Trial',
            'Quantity',
            'Products',
            'Expiration',
            'Activation Code',
            'Price',
            'Discount',
            'Tax',
            'Total',
            'State',
            'CC Fee',
            'Invoice ID',
          ]);
          const { endDate, startDate } = $scope.viewmodel.dateRange;
          const params = {
            start_date: startDate ? new Date(startDate) : null,
            end_date: endDate ? new Date(endDate) : null,
          };
          if (tableState?.search?.predicateObject) {
            Object.keys(tableState.search.predicateObject).forEach((key) => {
              params[key] = tableState.search.predicateObject[key];
            });
          }

          return reportService.getOrdersReport(params).then((orders) => {
            for (let i = 0; i < orders.length; i++) {
              reportData.push([
                tzService.parseFormatUserDate(orders[i].date_created, 'YYYY-MM-DD HH:mm:ss'),
                orders[i].order_id,
                orders[i].user_id,
                `${orders[i].user.first_name} ${orders[i].user.last_name}`,
                orders[i].user.email,
                orders[i].user.phone,
                orders[i].domain.company_name,
                orders[i].domain.name,
                orders[i].domain.sso,
                // eslint-disable-next-line no-nested-ternary
                orders[i].is_trial === 1
                  ? 'Trial' : orders[i].is_trial === 2 ? 'Partner' : null,
                orders[i].quantity,
                $filter('getProperty')(orders[i].products, 'name'),
                orders[i].subscription.length ? orders[i].subscription[0].date_expires : null,
                orders[i].coupon ? orders[i].coupon.code : null,
                $filter('currency')(orders[i].price),
                $filter('currency')(orders[i].discount),
                $filter('currency')(orders[i].tax),
                $filter('currency')(orders[i].total),
                orders[i].state,
                $filter('currency')(orders[i].cc_fee),
                orders[i].invoice_id,
              ]);
            }
            return reportData;
          });
        },
        loadDomains(tableState) {
          $scope.loading = true;

          const params = tableState
            ? {
              paginate: true,
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
            }
            : {
              paginate: true,
              page: 1,
            };
          if (tableState?.search?.predicateObject) {
            Object.keys(tableState.search.predicateObject).forEach((key) => {
              params[key] = tableState.search.predicateObject[key];
            });
          }

          reportService.getDomainReport(params).then((domains) => {
            $scope.viewmodel.domains = domains.items || domains;
            $scope.loading = false;

            if (tableState) {
              tableState.pagination.numberOfPages = Math.ceil(domains.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = domains.total;
            }
          });

          if (!$scope.viewmodel.domainsTotal) {
            $scope.actions.exportDomainReport();
          }
        },
        exportDomainReport() {
          const reportData = [];

          const header = [
            'Domain',
            'Affiliate',
            'Games',
            'Sessions',
            'Players',
            'Admins',
            'Creators',
            'Viewers',
            'Arcades',
          ];

          for (let i = 0; i < $scope.data.gameTypes.length; i++) {
            header.push(`${$scope.data.gameTypes[i].name} Total`);
            header.push(`${$scope.data.gameTypes[i].name} Subscription`);
          }

          header.push('Date Created');

          reportData.push(header);

          reportService.getDomainReport({}).then((domains) => {
            for (let i = 0; i < domains.length; i++) {
              const data = [
                domains[i].name,
                domains[i].sso,
                domains[i].total_games,
                domains[i].total_sessions,
                domains[i].total_players,
                domains[i].total_admins,
                domains[i].total_editors,
                domains[i].total_users,
                domains[i].hasArcade ? 'Yes' : null,
              ];

              for (let j = 0; j < $scope.data.gameTypes.length; j++) {
                const game_type = $scope.data.gameTypes[j].key;
                if (domains[i].game_types && domains[i].game_types[game_type]) {
                  data.push(domains[i].game_types[game_type].count);
                  data.push(domains[i].game_types[game_type].subscription);
                } else {
                  data.push(0);
                  data.push(null);
                }
              }

              data.push(tzService.parseFormatUserDate(domains[i].date_created, 'YYYY-MM-DD HH:mm:ss'));

              reportData.push(data);
            }

            $scope.viewmodel.domainsTotal = reportData;
          });
        },
        loadUsers(tableState) {
          $scope.loading = true;

          const params = tableState
            ? {
              paginate: true,
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
            }
            : {
              paginate: true,
              page: 1,
            };
          if (tableState?.search?.predicateObject) {
            Object.keys(tableState.search.predicateObject).forEach((key) => {
              params[key] = tableState.search.predicateObject[key];
            });
          }

          reportService.getUserReport(params).then((users) => {
            $scope.viewmodel.users = users.items || users;
            $scope.loading = false;

            if (tableState) {
              tableState.pagination.numberOfPages = Math.ceil(users.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = users.total;
            }
          });

          if (!$scope.viewmodel.userTotal) {
            $scope.actions.exportUserReport();
          }
        },
        exportUserReport() {
          const reportData = [];

          const header = [
            'Name',
            'Email Address',
            'User Type',
            'Domains',
            'Date Created',
          ];

          reportData.push(header);

          reportService.getUserReport({}).then((users) => {
            for (let i = 0; i < users.length; i++) {
              const data = [
                users[i].full_name,
                users[i].email,
                $filter('userType')(users[i].user_type),
                users[i].domains.join(', '),
                tzService.parseFormatUserDate(users[i].date_created, 'YYYY-MM-DD HH:mm:ss'),
              ];

              reportData.push(data);
            }

            $scope.viewmodel.userTotal = reportData;
          });
        },

        generateReportFilename: reportService.generateReportFilename,
      };
    },
  ]);
